export class CancelConnectAction {
    constructor(addressOrCode) {
        this.name = 'CancelConnect';
        this.isDeviceAction = false;
        this.data = {};
        if (addressOrCode.startsWith('XXConnectHSD50XX:')) {
            this.data.connectionCode = addressOrCode;
        }
        else {
            this.data.address = addressOrCode;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FuY2VsQ29ubmVjdEFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvQ2FuY2VsQ29ubmVjdEFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPQSxNQUFNLE9BQU8sbUJBQW1CO0lBSzlCLFlBQVksYUFBcUI7UUFKakIsU0FBSSxHQUFHLGVBQWUsQ0FBQztRQUN2QixtQkFBYyxHQUFHLEtBQUssQ0FBQztRQUNoQyxTQUFJLEdBQWdDLEVBQUcsQ0FBQztRQUc3QyxJQUFJLGFBQWEsQ0FBQyxVQUFVLENBQUMsbUJBQW1CLENBQUMsRUFBRTtZQUNqRCxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsR0FBRyxhQUFhLENBQUM7U0FDMUM7YUFBTTtZQUNMLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxHQUFHLGFBQWEsQ0FBQztTQUNuQztJQUNILENBQUM7Q0FDRiJ9